import type { HTMLAttributes, PropsWithChildren } from 'react';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { STYLE_DEFAULTS } from '@elfsight/lib-stripe-integration';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';

type TextProps = {
  color?: string;
  textStyle?: Partial<TextStyleValue>;
  className?: string;
};

export function Text({
  color,
  children,
  className,
  textStyle = { fontSize: STYLE_DEFAULTS.fontSize },
  ...forwardingProps
}: PropsWithChildren<TextProps & HTMLAttributes<HTMLDivElement>>) {
  return (
    <Typography
      className={createReadableClass(
        {
          component: CLASS_COMPONENT,
          element: 'text-block'
        },
        [className]
      )}
      color={color || 'inherit'}
      textStyle={{
        ...STYLE_DEFAULTS,
        ...textStyle
      }}
      {...forwardingProps}
    >
      {children}
    </Typography>
  );
}
